export type GtmEventName =
  | 'upload_started'
  | 'upload_completed'
  | 'theme_selected'
  | 'detail_level_selected'
  | 'generation_requested'
  | 'generation_completed'
  | 'generation_failed'
  | 'download_clicked'
  | 'share_clicked'
  | 'credit_spent'
  | 'credit_purchased'
  | 'subscription_checkout'
  | 'subscription_activated'
  | 'sign_up'
  | 'login'
  | 'logout'
  | 'page_view';

export type GtmParams = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: any[];
    gtmEvent?: (eventName: string, params?: GtmParams) => void;
  }
}

export function gtmEvent(eventName: GtmEventName, params: GtmParams = {}): void {
  if (typeof window === 'undefined') return;
  if (typeof window.gtmEvent === 'function') {
    window.gtmEvent(eventName, params);
    return;
  }
  // Fallback to direct dataLayer push
  window.dataLayer = window.dataLayer || [];
  try {
    window.dataLayer.push({ event: eventName, ...params });
  } catch {
    // no-op
  }
}
